declare var $: any;

export class SheetsLoader {
    static loadSheet(sheet) {
        $(document).find('#style_sheet').attr('href', 'assets/build/css/' + sheet + '.css');
    }
}
